import styled from "styled-components";

export const MeasureCardWrapper = styled.div`
  & .expand-contract-button {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover .expand-contract-button {
    opacity: 1;
  }
`;
